<template>
  <create :disabled="loading" :databank-id="databankId" :search-enabled="searchEnabled" :create-in-progress="createInProgress" class="mg-rem-b-3"
    @search="searchDbNumber"
    @search-close="closeSearchDbNumber"
    @create="addDbNumber"
    @remove-founded="removeFounded"
    @remove-all="removeAll"
  ></create>
  <div class="wd-100p-force">
    <data-table :columns="columnsActions" :items="[{}]" :max-height="16" :show-header="false" :show-search="false" :loading="false" :items-cnt="1"></data-table>
  </div>
  <div class="wd-100p-force" v-full-height="35">
    <data-table :columns="columns" :full-height="false" :items="items" :max-height="16" :show-header="false" :show-search="false" :loading="loading" :items-cnt="count"></data-table>
  </div>
  <div class="d-flex flex-row align-items-center justify-content-start wd-100p-force mg-rem-t-2 tx-right" v-if="!loading && items.length">
    <div class="d-flex flex-column align-items-end justify-content-start wd-100p-force mg-rem-r-2">
      <b>Страница:</b>
      <small>{{ (count - ((page - 1) * maxOnPage)) - items.length + 1 }} - {{ count - ((page - 1) * maxOnPage) }} / {{ count }}</small>
    </div>
    <div class="form-group mg-l-auto flex-shrink-none">
      <select class="form-control form-control-select pagination-select" :disabled="loading" v-model="page">
        <option v-for="_page in maxPage" v-bind:value="_page" v-html="maxPage - _page + 1"></option>
      </select>
    </div>
  </div>
</template>

<style>
.pagination-select {
  border-color: var(--cui-gray-500) !important;
  text-align: right;
}
</style>

<script>
import {h} from 'vue';
import Create from "@/entities/Databanks/Numbers/Create";
import Links from "@/entities/Databanks/Numbers/LinksClass";
import DataTable from "@/elements/Table";
import IconButton from "@/elements/IconLink";

export default {
  components: {IconButton, DataTable, Create },
  props: {
    databankId: { type: String }
  },
  data() {
    return {
      Links: null,
      loading: false,
      count: 1,

      searchNumber: null,
      page: 1,
      maxOnPage: 100,

      totalSelected: false,
      searchEnabled: false,
      createInProgress: false,

      filter: {
        filter: {
          databank_id: parseInt(this.$props.databankId)
        }
      },

      columns: [
        {
          header: '',
          width: '25px',
          value: (item) => {
            return h('input', {
              class: 'flex-shrink-none',
              checked: item.checked,
              type: 'checkbox',
              onClick: () => { item.checked = !item.checked; }
            })
          }
        },
        {
          header: 'Номер телефона',
          value: (item) => {
            return h('div', {
              class: 'wd-100p-force',
              onClick: () => { item.checked = !item.checked; }
            }, this.formatNumber(item.number + ''))
          }
        },
      ],

      items: [],
      createHandler: null,
    }
  },
  watch: {
    page: {
      handler() {
        this.init();
      }
    },
    totalSelected: {
      handler(val) {
        if (this.items.length) {
          this.items.forEach((item) => {
            item.checked = val;
          })
        }
      }
    }
  },
  computed: {
    columnsActions: {
      get() {
        return [
          {
            header: '',
            width: '25px',
            value: () => {
              return h('input', {
                class: 'flex-shrink-none',
                checked: this.totalSelected,
                type: 'checkbox',
                disabled: this.loading,
                onClick: () => { if (!this.loading) { this.totalSelected = !this.totalSelected } }
              })
            }
          },
          {
            header: '',
            float: 'right',
            value: () => {
              return h(IconButton, {
                className: 'btn btn-sm btn-link tx-12',
                icon: 'trash',
                label: 'Удалить выбранные',
                disabled: !this.someItemSelected,
                style: {'opacity': this.someItemSelected ? '1' : '0.3'},
                padding: '0',
                onClick: () => { this.removeSelected() }
              })
            }
          },
        ]
      }
    },
    someItemSelected: {
      get() {
        let result = false;
        if (this.items.length) {
          this.items.forEach((item) => {
            if (item.checked) { result = true; }
          })
        }
        return result;
      }
    },
    maxPage: { get() {
      const division = parseInt(parseInt(this.count) / this.maxOnPage);
      const reside = parseInt(this.count) - division * this.maxOnPage;
      return division + (reside > 0 ? 1 : 0);
    } }
  },
  methods: {
    formatNumber(number) {
      return '+' + number.substr(0, 1)+ ' (' + number.substr(1, 3)+ ') ' + number.substr(4,3) + '-' + number.substr(7,2) + '-' + number.substr(9, 2);
    },
    init() {
      let filter = {limit: this.maxOnPage, offset: (this.page - 1) * this.maxOnPage};
      if (this.searchNumber) {
        let search = this.searchNumber + '';
        if (search.length >= 11) {
          filter.filter = {'number': parseInt(search), databank_id: parseInt(this.$props.databankId)};
        } else {
          let searchMin = search;
          let searchMax = search;
          for (let i = 0; i < (11-search.length); i++) {
            searchMin += '0';
            searchMax += '9';
          }
          filter.range = { '>=': ['number', searchMin], '<=': ['number', searchMax]};
        }
      }
      this.Links.list(() => {
        this.totalSelected = false;
      }, null, filter);
    },
    searchDbNumber(number) {
      this.searchEnabled = true;
      this.searchNumber = number;
      this.init();
    },
    closeSearchDbNumber() {
      this.searchEnabled = false;
      this.searchNumber = '';
      this.init();
    },
    addDbNumber(number) {
      this.createInProgress = true;
      this.Links.create(this.$props.databankId, number, () => {
        this.emitter.emit('databank-changed', {id: this.$props.databankId});
        this.createInProgress = false;
        this.searchEnabled = false;
        this.init();
      }, () => {
        this.createInProgress = false;
        this.loading = false;
      });
    },
    removeFounded() {
      if (this.searchNumber) {
        let filter = null;

        let search = this.searchNumber + '';
        if (search.length >= 11) {
          filter = {filter: {'number': parseInt(search)}};
        } else {
          let searchMin = search;
          let searchMax = search;
          for (let i = 0; i < (11-search.length); i++) {
            searchMin += '0';
            searchMax += '9';
          }
          filter = {range: { '>=': ['number', searchMin], '<=': ['number', searchMax]}};
        }

        this.Links.removeAll(this.$props.databankId, () => {
          this.totalSelected = false;
          this.searchNumber = '';
          this.searchEnabled = false;
          this.emitter.emit('databank-changed', {id: this.$props.databankId})
          this.init();
        }, () => {
          this.loading = false;
          this.searchEnabled = false;
        }, filter);
      }
    },
    removeAll() {
      this.Links.removeAll(this.$props.databankId, () => {
        this.emitter.emit('databank-changed', {id: this.$props.databankId});
        this.init();
      }, () => {
        this.loading = false;
      });
    },
    removeSelected() {
      let pks = [];
      if (this.items.length) {
        this.items.forEach((item) => {
          if (item.checked) {
            pks.push(parseInt(item.number));
          }
        })
      }

      if (pks.length) {
        this.totalSelected = false;
        this.Links.remove(pks, this.$props.databankId, () => {
          this.emitter.emit('databank-changed', {id: this.$props.databankId});
          this.init();
        });
      }
    }
  },
  mounted() {
    this.Links = new Links(this);
    this.init();

    this.emitter.on('databank-numbers-list-changed', () => {
        this.init();
    });
  }
}
</script>